// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k5IOiZ {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  width: auto;
  min-width: 150px;
  max-width: 220px;
  height: auto;
  min-height: 40px;
  font-family: var(--font-family-base, 'Source Sans 3, sans-serif');
  background-color: transparent;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

.rYtt13 {
  cursor: pointer;
}

.FhGeoH {
  background-color: var(--header-company-selector-focus-bg);
  border: 1px solid var(--header-company-selector-focus-border);
}

.bmyxhO {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  min-width: 0;
}

.Rvwypl {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.424;
  color: var(--header-company-selector-text-color);
  margin: 0;
  width: 45px;
  height: 16px;
}

.OVmJzw {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.424;
  color: var(--header-company-selector-text-color);
  margin: 0;
  height: 16px;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

._FyIe6 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/HeaderCompanySelector/HeaderCompanySelector.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iEAAiE;EACjE,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yDAAyD;EACzD,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  width: auto;\n  min-width: 150px;\n  max-width: 220px;\n  height: auto;\n  min-height: 40px;\n  font-family: var(--font-family-base, 'Source Sans 3, sans-serif');\n  background-color: transparent;\n  border: 1px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.containerInteractive {\n  cursor: pointer;\n}\n\n.containerFocused {\n  background-color: var(--header-company-selector-focus-bg);\n  border: 1px solid var(--header-company-selector-focus-border);\n}\n\n.companyInfo {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex: 1;\n  min-width: 0;\n}\n\n.label {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.424;\n  color: var(--header-company-selector-text-color);\n  margin: 0;\n  width: 45px;\n  height: 16px;\n}\n\n.value {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.424;\n  color: var(--header-company-selector-text-color);\n  margin: 0;\n  height: 16px;\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chevron {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `k5IOiZ`,
	"containerInteractive": `rYtt13`,
	"containerFocused": `FhGeoH`,
	"companyInfo": `bmyxhO`,
	"label": `Rvwypl`,
	"value": `OVmJzw`,
	"chevron": `_FyIe6`
};
module.exports = ___CSS_LOADER_EXPORT___;
